import BaseApi from '~/api/base';
class GetFileUrl extends BaseApi {
    constructor() {
        super('/get-file-url');
    }
    getUrlById(primaryId, asDocx = false, bucket = undefined, redirectToErrorPage = false) {
        const queryParams = [];
        if (bucket)
            queryParams.push(`bucket_name=${bucket}`);
        if (asDocx)
            queryParams.push('as_docx=true');
        const queryParamsString = queryParams.length ? '?' + queryParams.join('&') : '';
        return super.getById(primaryId, redirectToErrorPage, queryParamsString);
    }
}
const GetFileUrlApi = new GetFileUrl();
export default GetFileUrlApi;
